import {safeBlob} from '@embertracking/common/data/fileTypes.mjs';

import {auth as firebaseAuth} from '-/firebase';
import {callFunction, resolveApiBase} from '-/data/utils';
import {assertUploadWithinLimit} from '-/data/uploadLimit';

export const getRequirement = assignmentId => callFunction('getRequirement', {assignmentId});

// Complete a FILE_UPLOAD step by uploading the member's file (multipart). The api
// stores it per-step (not the assignment-level evidence) and completes the step.
export const submitStepFile = ({assignmentId, stepId, file}) => {
    assertUploadWithinLimit(file);
    return callFunction(
        'submitStepFile',
        {assignmentId, stepId, ...(file ? {file} : {})},
        {headers: {'Content-Type': 'multipart/form-data'}}
    );
};

// Authoring preview: load the live draft definition (full, with quiz answer keys)
// for a requirement the author can write. Used by the Runner's preview mode.
export const getRequirementPreview = requirementId => callFunction('getRequirement', {requirementId});

export const recordStepProgress = params => callFunction('recordStepProgress', params);

export const submitQuiz = params => callFunction('submitQuiz', params);

export const completeRequirement = assignmentId => callFunction('completeRequirement', {assignmentId});

const OUTSTANDING = new Set(['ASSIGNED', 'IN_PROGRESS']);
export const isOutstanding = status => OUTSTANDING.has(status);

// viewRequirementFile streams the file with auth, so we can't drop the URL into an
// <iframe src>; fetch it with the bearer token and hand back an object URL.
export const fetchRequirementFileUrl = async ({requirementId, stepId, fileIndex = 0, assignmentId, draft}) => {
    const token = await firebaseAuth.currentUser.getIdToken();
    const params = new URLSearchParams({requirementId, stepId, fileIndex: String(fileIndex)});
    if (assignmentId) params.set('assignmentId', assignmentId);
    if (draft) params.set('draft', '1');
    const res = await fetch(`${resolveApiBase()}viewRequirementFile?${params.toString()}`, {
        headers: {Authorization: `Bearer ${token}`}
    });
    if (!res.ok) throw new Error('Failed to load file');
    const blob = safeBlob(await res.blob());
    return {url: URL.createObjectURL(blob), mimeType: blob.type};
};

// Stream an assignment's evidence file. The assignment-level credit evidence is
// staff-only; a per-step certificate (pass stepId) is viewable by staff or the
// owner. viewRequirementEvidence enforces both. Returns an object URL like the above.
export const fetchAssignmentEvidenceUrl = async (assignmentId, stepId, fileIndex) => {
    const token = await firebaseAuth.currentUser.getIdToken();
    const params = new URLSearchParams({assignmentId});
    if (stepId) params.set('stepId', stepId);
    if (fileIndex != null) params.set('fileIndex', fileIndex);
    const res = await fetch(`${resolveApiBase()}viewRequirementEvidence?${params.toString()}`, {
        headers: {Authorization: `Bearer ${token}`}
    });
    if (!res.ok) throw new Error('Failed to load evidence');
    const blob = safeBlob(await res.blob());
    return {url: URL.createObjectURL(blob), mimeType: blob.type};
};
